import React from 'react'

const Backend = () => {
  return (
    <div className='skills__content'>
            <h3 className='skills__title'>Additional Skills</h3>

            <div className='skills__box'>
                <div className='skills__group'>
                    <div className='skills__data'>
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">C++</h3>
                            <span className="skills__level">Advanced</span>
                        </div>
                    </div>

                    <div className='skills__data'>
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">OOPS</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>
                    
                    <div className='skills__data'>
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">SQL, DBMS</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>
                </div>
                <div className='skills__group'>
                    <div className='skills__data'>
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">Figma Designing</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    <div className='skills__data'>
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">Problem Solving</h3>
                            <span className="skills__level">Intermediate</span>
                        </div>
                    </div>

                    <div className='skills__data'>
                        <i class='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">GIT</h3>
                            <span className="skills__level">Basics</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Backend